export const SEED_CONFIG = 'config';
export const SEED_BONDING_CURVE = 'bonding_curve';
export const SEED_USER_INFO = 'user_info';
export const DCA_POLICY_METADATA_SEED = 'dca_policy_metadata';
export const DCA_POLICY_SEED = 'dca_policy';
